import { useLoadingAnimation } from '@/components/LoadingAnimation/useLoadingAnimation.hook';
import { DEFAULT_ERROR_MESSAGE } from '@/config/text.const';
import { HttpStatusCode } from '@/services/http/HttpStatusCodes';
import { importingToolHttpClient } from '@/services/http/clients/importingToolHttpClient';
import { notificationService } from '@/services/notification/notification.client';
import { ImportMode } from '../models/importMode.enum';

export type ImportingToolProcessDocumentFields = {
  DocumentId: UUID,
  Mode: ImportMode
};

type ProcessDocumentProps = {
  values: ImportingToolProcessDocumentFields;
  successCallback?: Function;
};

export default function useImportingToolProcessDocument() {
  const { toggleLoadingAnimation } = useLoadingAnimation();

  const proccessDocument = async ({ values, successCallback }: ProcessDocumentProps) => {
    toggleLoadingAnimation(true);

    const query = `/process-document/${values.DocumentId}/${ImportMode[values.Mode]}`;
    importingToolHttpClient.post(query, values)
      .then((uploadResult) => {
        if (uploadResult?.status === HttpStatusCode.OK) {
          successCallback?.();
          notificationService.open({
            title: 'Success',
            text: `File ${values.Mode == ImportMode.Import ? 'processing' : 'validation'} started`,
            type: 'success'
          });
        }
      })
      .catch((err) => {
        notificationService.open({
          title: `File ${values.Mode == ImportMode.Import ? 'processing' : 'validation'} error`,
          text: err?.message ?? DEFAULT_ERROR_MESSAGE,
          type: 'danger'
        });
      })
      .finally(() => toggleLoadingAnimation(false));
  };

  return {
    proccessDocument
  };
}
